import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/lebenslauf/components/frame/src/assets/anschreiben-logo-light.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')